module.exports = __webpack_public_path__ + "img/pic-04.7f5c420e.png";